import { 
  buildOAuthUrl, 
  createOAuthPopup, 
  generatePKCEPair, 
  parseCodeFromQuery as parseCode, 
} from "./oauth-pkce-helper";

const MICROSOFT_CLIENT_ID = process.env.REACT_APP_MICROSOFT_CLIENT_ID;
const MICROSOFT_TENANT = "common";
const REDIRECT_URI = `${window.location.origin}/microsoft/callback`;

export const signInWithMicrosoftPopup = async () => {
  const { codeVerifier, codeChallenge } = await generatePKCEPair();

  const authUrl = buildOAuthUrl(
    `https://login.microsoftonline.com/${MICROSOFT_TENANT}/oauth2/v2.0/authorize`,
    {
      client_id: MICROSOFT_CLIENT_ID,
      response_type: "code",
      redirect_uri: REDIRECT_URI,
      scope: "openid profile email User.Read",
      response_mode: "query",
      prompt: "select_account",
      code_challenge: codeChallenge,
      code_challenge_method: "S256",
    },
  );

  return createOAuthPopup({
    authUrl,
    popupTitle: "Microsoft Sign In",
    successMessageType: "MICROSOFT_AUTH_SUCCESS",
    errorMessageType: "MICROSOFT_AUTH_ERROR",
    providerName: "Microsoft",
    codeVerifier, 
  });
};

export const parseCodeFromQuery = () => parseCode("Microsoft");
